import { toast } from './toast';

// '__b64__' é o marcador que o cache local põe no lugar do base64; quando ele
// chega ao banco o arquivo já se perdeu. Baixar o marcador gerava um
// "index.html" em branco, então o botão avisa em vez de baixar.
export const anexoPerdido = (a) => !a?.dados || !String(a.dados).startsWith('data:');

export const baixarAnexo = (a) => {
  if (anexoPerdido(a)) {
    toast.aviso(`O arquivo "${a?.nome || ''}" não está mais salvo no sistema. Remova-o e anexe novamente pelo botão de edição.`);
    return;
  }
  const link = document.createElement('a');
  link.href = a.dados;
  link.download = a.nome;
  link.click();
};
